import React, { useState } from "react";
import AppIcon from "src/commun/composants/AppIcon";
import { AdminAccessGroup } from "src/domain/AdminAccessGroup";
import styles from "src/pages/admin/adminAccessGroup/AdminAcessGroupeForm.scss";
import AppInputFormik from "src/commun/composants/formulaire/formik/fields/AppInputFormik";
import { useFormikContext } from "formik";
import AppSelectFormik from "src/commun/composants/formulaire/formik/fields/AppSelectFormik";
import { AppSelectOption } from "src/commun/composants/formulaire/AppSelect/AppSelect";

const AdminAccessGroupRow = ({ accessGroup, onEdit, onDelete ,isDelete}: { accessGroup: AdminAccessGroup; onEdit: () => void; onDelete: () => void; isDelete: boolean }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isDeletew, setIsDelete] = useState(true);
  const [editedAccessGroup, setEditedAccessGroup] = useState(accessGroup);
  const { submitCount ,submitForm} = useFormikContext();


  const callSubmit = () =>{

    submitForm();
  }

  const typeAcces:AppSelectOption[]= [{value:"Interne",label:"Interne"},{value:"Entreprise",label:"Entreprise"}]
  return (
    <tr>
      {isEditing ? (
        <>
          <td><AppInputFormik name="accessGroup" formulaireSoumis={submitCount > 0} isRequired={false}/>
         </td>
          <td>
            <AppSelectFormik
              options={
                typeAcces
              }

              name="typeAcces"
              formulaireSoumis={submitCount > 0}
              defaultValue={""}
            />
           </td>
        </>
      ) : (
        <>
          <td>{accessGroup.accessGroup}</td>
          <td>{accessGroup.typeAcces}</td>
        </>
      )}
      <td>
        {isEditing ? (
          <>
            <input
              className={`btn__primary mt-3 btn--full--xs mr-5`}
              type="submit"
              name="valider"
              onClick={callSubmit}
              value={"Sauvegarder"}
            />
            <input
              className={`btn__primary mt-3 btn--full--xs mr-5`}
              type="button"
              name="annuler"
              onClick={()=>{setIsEditing(false)}}
              value={"annuler"}
            />
            <AppIcon
              name="validate"
              className={"icon-valider-plein"}
              active
              size="38px"
              onClick={() => {
                onEdit();
                setIsEditing(false);
              }}
            />
            <AppIcon
              name="cancel"
              className={"icon-close"}
              active
              size="38px"
              onClick={() => {
                setEditedAccessGroup(accessGroup);
                setIsEditing(false);
              }}
            />
          </>
        ) : (
          <>
            <AppIcon
              name="edit"
              className={styles.iconEdit}
              active
              size="38px"
              onClick={() => setIsEditing(true)}
            />
            {isDelete&& <AppIcon
              name="fermer"
              className={"icon-close"}
              active
              size="38px"
              style={{color:"red"}}
              onClick={onDelete}
            />}
          </>
        )}
      </td>
    </tr>
  );
};


export default AdminAccessGroupRow;
